import { FC } from "react";
import { OverviewSourceUsageDotProps } from "./types";
import { DOT_R } from "../const";

const ACTIVE_DOT_SHADOW = "drop-shadow(0px 12px 18px rgba(0, 54, 78, 0.18))";

/**
 * Renders dot for last data point (dot) or hovered point with shadow (activeDot).
 */
const OverviewSourceUsageDot: FC<OverviewSourceUsageDotProps> = ({
  cx,
  cy,
  payload,
  fillColor,
  active,
  fill,
}) => {
  if (cx == null || cy == null) {
    return null;
  }

  if (active) {
    return (
      <svg
        x={cx - DOT_R}
        y={cy - DOT_R}
        style={{ filter: ACTIVE_DOT_SHADOW }}
      >
        <circle cx={DOT_R} cy={DOT_R} r={DOT_R} fill={fill ?? fillColor} />
      </svg>
    );
  }

  if (!payload?.isLast) {
    return null;
  }

  return (
    <svg x={cx - DOT_R} y={cy - DOT_R}>
      <circle cx={DOT_R} cy={DOT_R} r={DOT_R} fill={fillColor} />
    </svg>
  );
};

export default OverviewSourceUsageDot;
